module.exports = __webpack_public_path__ + "img/preview3.833e7992.png";